import {Link} from "react-router-dom";
import {css} from "@panda/css";

import {Image} from "@pg-design/image-module";
import {kmAppLink} from "@pg-mono/km-routes";
import {KM_COMMON_TEST_IDS} from "@pg-mono/test-ids";

import {useMatchedSite} from "@/features/km_app/hooks/use_matched_site";
import {useMatchedView} from "@/features/km_app/hooks/use_matched_view";
import {NavigationAmplitudeTracker} from "@/features/tracking/amplitude/navigation_amplitude_tracker";
import {useRefererData} from "@/hooks/use_referer_data";

export const NavLogo = () => {
    const {logo, logoSize} = useRefererData();
    const site = useMatchedSite();
    const viewType = useMatchedView();
    const dashboardPath = kmAppLink.site.dashboard({site});

    const handleClick = () => {
        NavigationAmplitudeTracker.headerLogoClick(viewType);
    };

    return (
        <Link className={navLogoLinkStyle} data-testid={KM_COMMON_TEST_IDS.NAV_LOGO} onClick={handleClick} to={dashboardPath}>
            <Image alt="logo" height={logoSize.height} imageClassName={navLogoImageStyle} src={logo} width={logoSize.width} />
        </Link>
    );
};

const navLogoLinkStyle = css({
    display: "block",
    lineHeight: 0,
    minWidth: 0,
    width: "fit-content",

    "&:focus-visible": {
        outline: "2px solid var(--colors-info)",
        outlineOffset: "2px"
    }
});

const navLogoImageStyle = css({
    display: "block",
    height: "auto",
    maxWidth: "100%"
});
import {Link} from "react-router-dom";
import {css} from "@panda/css";

import {Image} from "@pg-design/image-module";
import {kmAppLink} from "@pg-mono/km-routes";
import {KM_COMMON_TEST_IDS} from "@pg-mono/test-ids";

import {useMatchedSite} from "@/features/km_app/hooks/use_matched_site";
import {useMatchedView} from "@/features/km_app/hooks/use_matched_view";
import {NavigationAmplitudeTracker} from "@/features/tracking/amplitude/navigation_amplitude_tracker";
import {useRefererData} from "@/hooks/use_referer_data";

export const NavLogo = () => {
    const {logo, logoSize} = useRefererData();
    const site = useMatchedSite();
    const viewType = useMatchedView();
    const dashboardPath = kmAppLink.site.dashboard({site});

    const handleClick = () => {
        NavigationAmplitudeTracker.headerLogoClick(viewType);
    };

    return (
        <Link className={navLogoLinkStyle} data-testid={KM_COMMON_TEST_IDS.NAV_LOGO} onClick={handleClick} to={dashboardPath}>
            <Image alt="logo" height={logoSize.height} imageClassName={navLogoImageStyle} src={logo} width={logoSize.width} />
        </Link>
    );
};

const navLogoLinkStyle = css({
    display: "block",
    lineHeight: 0,
    minWidth: 0,
    width: "fit-content",

    "&:focus-visible": {
        outline: "2px solid var(--colors-info)",
        outlineOffset: "2px"
    }
});

const navLogoImageStyle = css({
    display: "block",
    height: "auto",
    maxWidth: "100%"
});
